<template>
  <v-tile
    ref="tile"
    :product="product"
  >
    <v-highlight
      :product="product"
      :trailer-mode="TrailerMode.HERO"
      class="c-highlight--hero-slider"
      @trailer-ended="onTrailerEnded"
      @viewport-leave="onHighlightViewportLeave"
    >
      <h3 class="o-typography__headline1 u-bold u-text-transform-none u-ellipsis">
        {{ mainTitle }}
      </h3>
      <div class="u-flex">
        <v-badge :product="product"></v-badge>
      </div>
      <p class="o-typography__body1 u-bold u-ellipsis-3-lines">
        {{ product.lead | truncate }}
      </p>
      <template #buttons>
        <v-play-product
          v-if="isPlayable || isFuture"
          autoplay-redirect
          outline
          show-label
          :product="product"
        ></v-play-product>
      </template>
    </v-highlight>
  </v-tile>
</template>
<script>
  import { VBadge, VHighlight, VPlayProduct, VTile } from '@/index/shared/components';
  import { meta, truncate } from '@/index/shared/filters';
  import { productMixin } from '@/index/shared/mixins';
  import { TrailerMode } from '@/shared/enums';
  import { heroMainTitleMixin } from '@/index/components/section/mixins';

  export default {
    components: {
      VBadge,
      VHighlight,
      VPlayProduct,
      VTile,
    },
    enums: {
      TrailerMode,
    },
    filters: {
      meta,
      truncate,
    },
    mixins: [
      productMixin,
      heroMainTitleMixin,
    ],
    props: {
      product: Object,
    },
    computed: {
      title() {
        return this.$options.filters.meta(this.product, 'richTitle');
      },
    },
    methods: {
      onHighlightViewportLeave() {
        this.$emit('highlight-viewport-leave');
      },
      onTrailerEnded() {
        this.$emit('trailer-ended');
      },
      playTrailer() {
        this.$nextTick(() => this.$refs.trailer.play());
      },
      stopTrailer() {
        this.$refs.trailer.stop();
      },
    },
  };
</script>
